export default {
  name: 'ConfirmSave',
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    title: {
      required: true,
      type: String,
      default: ''
    },
    message: {
      required: true,
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  mounted () {
    this.dialog = true
  },
  methods: {
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
